<p-steps [model]="pagineValidaConsegna" [readonly]="true" [activeIndex]="activeIndex" >  </p-steps> 
   <div class="d-flex mt-1 ">
    <ng-container [ngSwitch]="activeIndex">
      <ng-container *ngSwitchCase="0">
        <form [formGroup]="verificaRETForm">
          <div class="grid formgrid p-fluid ">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormRET()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="cui"  binary="true"   inputId="checkboxCUI" > </p-checkbox>
              <label for="checkboxCUI" class="ml-1 mb-0" style="font-size: 11px;">Il CUI è <span class="font-semibold">{{pratica.cui}}</span></label>
            </div>
            <div class="field col-5 flex align-items-center">
              <p-checkbox formControlName="denominazione"  binary="true"   inputId="checkboxDenominazione" > </p-checkbox>
              <label for="checkboxDenominazione" class="ml-1 mb-0" style="font-size: 11px;">Il nome della scuola è <span class="font-semibold">{{pratica.denominazione.toUpperCase()}}</span></label>
            </div>
           
            <div class="field col-3 flex align-items-center mt-2">
              <p-checkbox formControlName="data"   binary="true"  inputId="checkboxData" > </p-checkbox>
              <label for="checkboxData" class="ml-1 mb-0" style="font-size: 12px;">La <span class="font-semibold">data</span> è corretta</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
           
            <div class="field col-4 flex align-items-center">
              <p-checkbox formControlName="indirizzo"  binary="true"   inputId="checkboxIndirizzo" > </p-checkbox>
              <label for="checkboxIndirizzo" class="ml-1 mb-0" style="font-size: 11px;">L'indirizzo è <span class="font-semibold">{{pratica.indirizzo.toUpperCase()}}</span></label>
            </div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="comune"  binary="true"  inputId="checkboxComune" > </p-checkbox>
              <label for="checkboxComune" class="ml-1 mb-0" style="font-size: 12px;">Il comune è <span class="font-semibold">{{pratica.comune.toUpperCase()}}</span></label>
            </div>
            <div class="field col-4 flex align-items-center">
              <p-checkbox formControlName="coordinate"  binary="true"   inputId="checkboxCoordinate" > </p-checkbox>
<!--               <label *ngIf="pratica.coordinateScuola" for="checkboxCoordinate" class="ml-1 mb-0" style="font-size: 11px;">Le coordinate sono <span class="font-semibold">{{pratica.coordinateScuola.latitude}} - {{pratica.coordinateScuola.longitude}}</span></label>
 -->              <label for="checkboxCoordinate" class="ml-1 mb-0" style="font-size: 11px;">Le coordinate sono corrette</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-4 flex align-items-center">
              <p-checkbox formControlName="tipologiaGara"  binary="true"  inputId="checkboxTipologiaGara" > </p-checkbox>
              <label for="checkboxTipologiaGara" class="ml-1 mb-0" style="font-size: 11px;">La sede di gara è <span class="font-semibold">{{pratica.tipoSede.toUpperCase()}}</span></label>
            </div>
            <div class="field col-4 flex align-items-center">
              <p-checkbox formControlName="tipologiaEffettiva"  binary="true"   inputId="checkboxTipologiaEffettiva" > </p-checkbox>
              <label for="checkboxTipologiaEffettiva" class="ml-1 mb-0" style="font-size: 11px;">La sede effettiva è <span class="font-semibold">{{pratica.tipoSedeEffettiva.toUpperCase()}}</span></label>
            </div>
            <div class="field col-2 flex align-items-center">
              <p-checkbox formControlName="carrier"  binary="true"   inputId="checkboxCarrier" > </p-checkbox>
              <label for="checkboxCarrier" class="ml-1 mb-0" style="font-size: 11px;">Carrier OK</label>
            </div>
            <div class="field col-2 flex align-items-center">
              <p-checkbox formControlName="backup"  binary="true"   inputId="checkboxBackup" > </p-checkbox>
              <label for="checkboxBackup" class="ml-1 mb-0" style="font-size: 11px;">Backup OK</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-12 flex align-items-center">
              <p-checkbox formControlName="rischi"  binary="true"   inputId="checkboxRischi" > </p-checkbox>
              <label for="checkboxRischi" class="ml-1 mb-0" style="font-size: 12px;">Presenza dei rischi specifici nella tabella 4</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-12">
              <label for="noteRET" style="font-size: 12px;">Note</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteRET" rows="3" [autoResize]="true" formControlName="note" pInputTextarea></textarea>
              </span>
            </div>
          </div>
        </form>
      </ng-container>
       <ng-container *ngSwitchCase="1">
        <form [formGroup]="verificaDUVRIForm">
          <div class="grid formgrid p-fluid">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormDUVRI()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-12 flex align-items-center mt-2">
              <p-checkbox formControlName="duvriOK"  binary="true"   inputId="checkboxDuvriOK" > </p-checkbox>
              <label for="checkboxDuvriOK" class="ml-1 mb-0" style="font-size: 12px;">E' presente un DUVRI <i>specifico</i> o un DUVRI <i>ricognitivo</i></label>
            </div>
            <div class="field col-12 flex align-items-center mt-1">
              <p-checkbox formControlName="firmatoDaScuola"  binary="true"   inputId="checkboxFirmatoDaScuola" > </p-checkbox>
              <label for="checkboxFirmatoDaScuola" class="ml-1 mb-0" style="font-size: 12px;">E' firmato dal <b>dirigente</b> o dal <b>delegato</b></label>
            </div>
            <div class="field col-12 flex align-items-center mt-1">
              <p-checkbox formControlName="firmatoDaOperatore"  binary="true"   inputId="checkboxFirmatoDaOperatore" > </p-checkbox>
              <label for="checkboxFirmatoDaOperatore" class="ml-1 mb-0" style="font-size: 12px;">E' firmato dall'<b>operatore</b></label>
            </div>
            <div class="field col-6 flex align-items-center mt-1">
              <p-checkbox formControlName="data"   binary="true"  inputId="checkboxData" > </p-checkbox>
              <label for="checkboxData" class="ml-1 mb-0" style="font-size: 12px;">La <span class="font-semibold">data</span> è corretta</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-12">
              <label for="noteDUVRI" style="font-size: 12px;">Note</label>
                <span class="p-input-icon-left">
                  <i class="pi pi-info-circle"></i>
                  <textarea id="noteDUVRI" rows="3" [autoResize]="true" formControlName="note" pInputTextarea></textarea>
                </span>
            </div>
          </div>
        </form>
      </ng-container> 
      <ng-container *ngSwitchCase="2">
        <form [formGroup]="verificaVerbaleForm">
          <div class="grid formgrid p-fluid">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormVerbale()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-12 flex align-items-center mt-2">
              <p-checkbox formControlName="cui"  binary="true"   inputId="checkboxCUI" > </p-checkbox>
              <label for="checkboxCUI" class="ml-1 mb-0" style="font-size: 11px;">Il CUI è <span class="font-semibold">{{pratica.cui}}</span></label>
            </div>
            <div class="field col-12 flex align-items-center">
              <p-checkbox formControlName="denominazione"  binary="true"   inputId="checkboxDenominazione" > </p-checkbox>
              <label for="checkboxDenominazione" class="ml-1 mb-0" style="font-size: 11px;">Il nome della scuola è <span class="font-semibold">{{pratica.denominazione.toUpperCase()}}</span></label>
            </div>
            <div class="field col-12 flex align-items-center">
              <p-checkbox formControlName="data"   binary="true"  inputId="checkboxData" > </p-checkbox>
              <label for="checkboxData" class="ml-1 mb-0" style="font-size: 12px;">La <span class="font-semibold">data</span> è corretta</label>
            </div>
            <div class="field col-12 flex align-items-center">
              <p-checkbox formControlName="localeTecnico"   binary="true"  inputId="checkboxLocaleTecnico" > </p-checkbox>
              <label for="checkboxLocaleTecnico" class="ml-1 mb-0" style="font-size: 12px;">Il locale tecnico è <b>corretto</b></label>
            </div>
            <div class="field col-6 flex align-items-center mt-1">
              <p-checkbox formControlName="firmatoDaScuola"  binary="true"   inputId="checkboxFirmatoDaScuola" > </p-checkbox>
              <label for="checkboxFirmatoDaScuola" class="ml-1 mb-0" style="font-size: 12px;">E' firmato dal <b>dirigente</b> o dal <b>delegato</b></label>
            </div>
            <div class="field col-6 flex align-items-center mt-1">
              <p-checkbox formControlName="firmatoDaOperatore"  binary="true"   inputId="checkboxFirmatoDaOperatore" > </p-checkbox>
              <label for="checkboxFirmatoDaOperatore" class="ml-1 mb-0" style="font-size: 12px;">E' firmato dall'<b>operatore</b></label>
            </div>
            
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-12">
              <label for="noteVerbale" style="font-size: 12px;">Note</label>
                <span class="p-input-icon-left">
                  <i class="pi pi-info-circle"></i>
                  <textarea id="noteVerbale" rows="3" [autoResize]="true" formControlName="note" pInputTextarea></textarea>
                </span>
            </div>
          </div>
        </form>
      </ng-container> 
    </ng-container>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">

        <p-button icon="pi pi-arrow-left" class="p-button-text mr-2" (click)="activeIndex = activeIndex - 1" [disabled]="activeIndex === 0 "></p-button>
        <p-button icon="pi pi-arrow-right" class="p-button-text mr-1" (click)="changePage()" [disabled]="checkNextStep()"></p-button>
        <p-button  icon="pi pi-check" label="Conferma"
        class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isVerificandoConsegna"></p-button>
 </div>
    <p-toast />
    <p-confirmDialog /> 